export const USER_TYPE_OPTIONS = [
    { label: 'Agent', value: 'AGENT' },
    { label: 'System User', value: 'SYSTEM_USER' },
];
export const USER_ACTIVATION_STATUS_OPTIONS = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Suspend', value: 'SUSPEND' },
    { label: 'Delete', value: 'DELETE' },
    { label: 'Lock', value: 'LOCK' },
];
export const USER_ACTIVATION_SHIFT_OPTIONS = [
    { label: 'First', value: 'FIRST' },
    { label: 'Second', value: 'SECOND' },
    { label: 'Third', value: 'THIRD' },
];
export const defaultValue = {
    username: '',
    userType: 'AGENT',
    name: '',
    email: '',
    phoneIp: '',
    phoneUser: '',
    phonePassword: '',
    phonePort: '',
    contactNumber: '',
    position: '',
    shift: 'FIRST',
    status: 'ACTIVE',
    userId: undefined,
    branch: {
        id: undefined,
        branchName: '',
    },
};
function displayNameFromUser(user) {
    if (user.fullName?.trim())
        return user.fullName.trim();
    return [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
}
/** IAM login is the canonical email/username for activation (e.g. testuser@gmail.com). */
export function resolveIamLoginEmail(user) {
    if (!user)
        return '';
    return (user.login ?? user.email ?? user.username ?? '').trim();
}
function crmUserIdFromRow(user) {
    const userId = user.id != null && user.id !== '' ? Number(user.id) : undefined;
    return Number.isFinite(userId) ? userId : undefined;
}
/** Prefill locked fields from the Users table row (IAM / CRM create-user response). */
export function mapUserToActivationForm(source) {
    if (!source) {
        return { ...defaultValue, branch: { ...defaultValue.branch } };
    }
    if ('userType' in source && source.userType && !('login' in source)) {
        return {
            ...defaultValue,
            ...source,
            // branch: {
            //   ...defaultValue.branch,
            //   ...source.branch,
            // },
        };
    }
    const user = source;
    const userId = crmUserIdFromRow(user);
    const loginEmail = resolveIamLoginEmail(user);
    // const defaultBranchId =
    //   (user as { defaultBranchId?: number | null }).defaultBranchId ??
    //   (user as { defaultBranch?: IUserActivationBranch | null }).defaultBranch?.id;
    const email = loginEmail;
    return {
        ...defaultValue,
        username: email,
        name: displayNameFromUser(user),
        email,
        userId,
        phoneIp: user.phoneIp ?? '',
        phoneUser: user.phoneUser ?? '',
        phonePassword: user.phonePassword ?? '',
        phonePort: user.phonePort != null ? String(user.phonePort) : '',
        status: user.status ?? 'NEW',
        userType: user.userType ?? 'AGENT',
        // branch: {
        //   id: defaultBranchId != null ? Number(defaultBranchId) : undefined,
        //   branchName:
        //     (user as { defaultBranch?: IUserActivationBranch | null }).defaultBranch?.branchName ?? '',
        // },
    };
}
/**
 * Merge activation profile from `GET /api/users?userId.equals={crmUserId}` with locked fields
 * from the Users table row.
 */
export function mergeActivationFromUserAndApi(user, api) {
    const fromUser = mapUserToActivationForm(user);
    const loginEmail = fromUser.email?.trim() || fromUser.username?.trim() || '';
    if (!api || api.id == null) {
        return fromUser;
    }
    return {
        ...fromUser,
        ...api,
        name: fromUser.name,
        userId: fromUser.userId,
        status: fromUser.status ?? api.status,
        email: loginEmail,
        username: loginEmail,
        userType: api.userType ?? fromUser.userType,
        shift: api.shift ?? fromUser.shift,
        // branch: {
        //   ...fromUser.branch,
        //   ...api.branch,
        // },
        id: api.id,
    };
}
export function toUserActivationPayload(data) {
    const submitStatus = data.status === 'NEW' ? 'ACTIVE' : (data.status ?? 'ACTIVE');
    const email = data.email?.trim() ?? '';
    return {
        ...(data.id != null ? { id: Number(data.id) } : {}),
        username: email || data.username?.trim() || '',
        userType: data.userType ?? 'AGENT',
        name: data.name?.trim() ?? '',
        email,
        phoneIp: data.phoneIp?.trim() || undefined,
        phoneUser: data.phoneUser?.trim() || undefined,
        phonePassword: data.phonePassword?.trim() || undefined,
        phonePort: data.phonePort?.trim() || undefined,
        contactNumber: data.contactNumber?.trim() || undefined,
        position: data.position?.trim() || undefined,
        shift: data.shift ?? 'FIRST',
        status: submitStatus,
        userId: data.userId != null ? Number(data.userId) : null,
        // branch: {
        //   id: data.branch?.id != null ? Number(data.branch.id) : null,
        //   branchName: data.branch?.branchName?.trim() ?? '',
        // },
    };
}
/** Resource id for PUT `/api/users/{id}` — prefer loaded activation id, else CRM user id. */
export function resolveUserActivationPutId(data, crmUserId) {
    if (data.id != null && Number(data.id) > 0) {
        return Number(data.id);
    }
    if (crmUserId != null && Number(crmUserId) > 0) {
        return Number(crmUserId);
    }
    if (data.userId != null && Number(data.userId) > 0) {
        return Number(data.userId);
    }
    return undefined;
}
